import React from "react";
import "./providerAssignCell.css";

// The service provider column: who is on a booking, and the way to put someone on it.
//   display     the people to show (already title-cased / step-formatted), or "" when nobody is on it
//   isPlaceholder  the API's stand-in for nobody ("Assign Crew"...): it is not a person
//   canAssign   the viewer may assign, and the booking is open and has nobody in the service role
//   closed      Completed / Cancelled: nothing is left to do, so an empty cell is not a to-do
//
// With nobody on it, the empty state IS the action - one "+ Assign" button, never a
// label plus a second button that wraps under it in a narrow column.
export default function ProviderAssignCell({ display, isPlaceholder, canAssign, closed, onAssign, label = "provider" }) {
  const handle = (e) => {
    e.stopPropagation();
    onAssign?.();
  };

  if (canAssign) {
    if (!display) {
      return (
        <button type="button" className="pac-btn pac-btn-empty" onClick={handle} aria-label={`Assign ${label}`}>
          <span aria-hidden="true">+</span> Assign
        </button>
      );
    }
    // Someone is on some steps but the service role is empty: show them, then the action.
    return (
      <span className="pac-row">
        <span className="pac-names">{display}</span>
        <button type="button" className="pac-btn pac-btn-small" onClick={handle} aria-label={`Assign ${label}`}>
          Assign
        </button>
      </span>
    );
  }

  if (display) return <span className="pac-names">{display}</span>;
  if (isPlaceholder) {
    return closed ? <span className="pac-none">Not assigned</span> : <span className="pac-open">Unassigned</span>;
  }
  return <span>-</span>;
}
